/*
 * Masculino Latino: pack ladder logic. One rule everywhere (BUILD_SPEC 5.5).
 *
 * IMPORTANT: this module only DISPLAYS the ladder. The real discount must be
 * configured separately in Shopify (automatic quantity discount, a discount app
 * or a checkout app) using exactly the same tier numbers as
 * Theme settings > Masculino: Pack ladder. [TODO: which mechanism]
 *
 * The tier is the total number of `pack-eligible` pieces in the cart, any mix of
 * products, colours and sizes.
 */
(function () {
  const cfg = (window.mlSettings && window.mlSettings.pack) || { tiers: [] };

  const tiers = (cfg.tiers || [])
    .filter((t) => t && t.name && Number(t.min) > 0)
    .map((t) => ({ index: t.index, name: t.name, min: Number(t.min), off: Number(t.off) || 0, badge: t.badge || '' }))
    .sort((a, b) => a.min - b.min);

  /** Indian-formatted rupees from a rupee amount: 1299 -> "₹1,299", 124999 -> "₹1,24,999". */
  function formatRupees(amount) {
    const n = Math.round(Math.abs(Number(amount) || 0));
    const s = String(n);
    let out = s;
    if (s.length > 3) {
      const last3 = s.slice(-3);
      const rest = s.slice(0, -3).replace(/\B(?=(\d{2})+(?!\d))/g, ',');
      out = rest + ',' + last3;
    }
    return (amount < 0 ? '-' : '') + '₹' + out;
  }

  /** Current tier for a piece count, or null when below the first tier. */
  function getTier(pieces) {
    let current = null;
    tiers.forEach((t) => {
      if (pieces >= t.min) current = t;
    });
    return current;
  }

  /** Next tier above the piece count, with pieces still needed and the total saving there. */
  function getNextTier(pieces) {
    const next = tiers.find((t) => t.min > pieces);
    if (!next) return null;
    return { tier: next, needed: next.min - pieces, saving: next.off * next.min };
  }

  /** Total display saving in rupees for a piece count. */
  function savingFor(pieces) {
    const t = getTier(pieces);
    return t ? t.off * pieces : 0;
  }

  function tierByIndex(index) {
    return tiers.find((t) => String(t.index) === String(index)) || null;
  }

  function tierByName(name) {
    if (!name) return null;
    const n = String(name).toLowerCase();
    return tiers.find((t) => t.name.toLowerCase() === n) || null;
  }

  window.MLPack = {
    tiers,
    getTier,
    getNextTier,
    savingFor,
    formatRupees,
    tierByIndex,
    tierByName,
    defaultTier: () => tierByIndex(cfg.defaultTier) || tiers[0] || null,
    prepaidOnly: !!cfg.prepaidOnly,
    eligibleTag: cfg.eligibleTag || 'pack-eligible',
  };
})();